export class InvalidTrustedOriginError extends Error {
  constructor(origin: string) {
    super(
      `Invalid trusted origin: ${origin}. Make sure it is a fully qualified URL e.g. https://stripe.com and is a trusted origin. If you are sure it is a trusted origin, you can pass it to the UNSAFE_allowedTrustedOrigins option.`,
    );
    this.name = 'InvalidTrustedOriginError';
  }
}
